function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var JSON = require('json-bigint');
var ArcadeMainTemplate = require('./main.template');
var ArcadeSidebar = require('./sidebar');
var ArcadeTeasers = require('./teasers');
var ArcadeMain = /*#__PURE__*/function () {
  function ArcadeMain(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'body';
    _classCallCheck(this, ArcadeMain);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.sidebar = new ArcadeSidebar(app, mod, '.arcade-sidebar');
    this.teasers = new ArcadeTeasers(app, mod, '.arcade-teasers');
    var league_hook = app.modules.returnFirstRespondTo('leagues-for-arcade');
    if (league_hook) {
      app.connection.on('league-rankings-render-request', function () {
        var _iterator = _createForOfIteratorHelper(league_hook.returnLeagues()),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var league = _step.value;
            var card = document.querySelector(".arcade-teaser[data-league=\"".concat(league.id, "\"] .arcade-teaser-footer"));
            if (card) {
              var html = '';
              if (league.rank > 0) {
                html = "<div class=\"leaderboard-rank arcade-invite-badge\">".concat(league.rank, "</div>");
              }
              card.innerHTML = html;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    }
    this.intersectionObserver = new IntersectionObserver(function (entries) {
      var gameListContainer = document.querySelector('.arcade-main');
      entries.forEach(function (entry) {
        if (entry.intersectionRatio <= 0) {
          if (entry.target.id == 'top-of-game-list') {
            gameListContainer.classList.add('can-scroll-up');
          } else {
            gameListContainer.classList.add('can-scroll-down');
          }
        } else {
          if (entry.target.id == 'top-of-game-list') {
            gameListContainer.classList.remove('can-scroll-up');
          } else {
            gameListContainer.classList.remove('can-scroll-down');
          }
        }
      });
    });
  }
  return _createClass(ArcadeMain, [{
    key: "showInitializer",
    value: function showInitializer(game_id) {
      if (!this.mod.browser_active) return;
      this.mod.render('lounge_overlay', {
        game_id: game_id
      });
    }
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (document.querySelector('.saito-container')) {
                this.app.browser.replaceElementBySelector(ArcadeMainTemplate(this.app, this.mod), '.saito-container');
              } else {
                this.app.browser.addElementToSelector(ArcadeMainTemplate(this.app, this.mod), this.container);
              }
              this.teasers.render();
              this.sidebar.render();
              _context.n = 1;
              return this.app.modules.renderInto('.arcade-sidebar');
            case 1:
              this.attachEvents();
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "renderInvites",
    value: function renderInvites() {
      if (!this.mod.browser_active) return;
      if (!this.sidebar || !this.sidebar.invites) return;
      this.sidebar.renderInvites();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      // start observing
      this.intersectionObserver.observe(document.getElementById('top-of-game-list'));
      this.intersectionObserver.observe(document.getElementById('bottom-of-game-list'));
      Array.from(document.querySelectorAll('.arcade-teaser')).forEach(function (game) {
        game.onclick = function (e) {
          e.stopPropagation();
          var league_id = e.currentTarget.getAttribute('data-league');
          if (e.currentTarget.classList.contains('arcade-teaser-install')) {
            var c = confirm('Do you want to install this game? This will take you to the app download site:');
            if (c) {
              var link = '';
              var modname = e.currentTarget.getAttribute('data-id');
              for (var z = 0; z < _this.app.modules.mods.length; z++) {
                if (modname === _this.app.modules.mods[z].name) {
                  link = _this.app.modules.mods[z].link;
                }
              }
              if (link != '') {
                navigateWindow(link, 300);
                return;
              }
              return;
            }
            return;
          }
          if (league_id) {
            _this.app.connection.emit('league-overlay-render-request', league_id);
          } else {
            var _modname = e.currentTarget.getAttribute('data-id');
            _this.app.connection.emit('arcade-launch-game-wizard', {
              game: _modname
            });
          }
        };
      });
    }
  }]);
}();
module.exports = ArcadeMain;